var ApplicationContext = require("../shared/config/ApplicationContext.js");
var RegionUtil = require("../shared/util/RegionUtil.js");
const SessionRecovery = require("../datastore/SessionRecovery.js");

class ContentServerClient{

    constructor(){
        this.deleteAsset = this.deleteAsset.bind(this);
        this.publishAsset = this.publishAsset.bind(this);
    }

    createResource(handleError, resource, type){
        return this.request(
            "create this resource",
            handleError,
            'POST', this.getAssetPath(type),
            {'Content-Type': 'application/json'},
            resource
        );
    }

    importEagleLibraryURL(handleError, id, url, matchAssets){
        return this.request(
            "import this library by URL",
            handleError,
            'POST', `${this.getAssetPath("libraries", id)}/import?libraryURL=${url}&matchAssets=${matchAssets}`,
            {},
            null
        );
    }

    importEagleLibraryFile(handleError, id, file, matchAssets){
        let data = new FormData();
        data.append(file.name, file, file.name)
        return this.request(
            "get this import status",
            handleError,
            'POST', `${this.getAssetPath("libraries", id)}/import?matchAssets=${matchAssets}`,
            {},
            data
        );
    }

    importStatus(handleError, id, url){
        return this.request(
            "get this import status",
            handleError,
            'GET', `${this.getAssetPath("libraries", id)}/import/status`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    vendorImportStatus(handleError, id, url){
        return this.request(
            "get this vendor import status",
            handleError,
            'GET', `${this.getAssetPath("libraries", id)}/import/status?vendor_import=true`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    // TODO split these into 4 functions (delete/undelete/publish/unpublish)
    deleteAsset (handleError, id, type, recursive = true, toDelete = true){
        return this.request(
            "delete this asset",
            handleError,
            'PUT', `${this.getAssetPath(type, id)}/delete`,
            {'Content-Type': 'application/json'},
            { 'action': (toDelete)? "delete" : "undelete", recursive }
        )
    };

    publishAsset (handleError, id, type, recursive = true, toPublish = true){
        return this.request(
            "publish this asset",
            handleError,
            'PUT', `${this.getAssetPath(type, id)}/publish`,
            {'Content-Type': 'application/json'},
            { "action": (toPublish)? "publish" : "unpublish", recursive }
        )
    };

    async exportLibrary (handleError, library) {
        try {
            const { id } = library.resource;
            if (!id) return;

            return this.request(
                "export library",
                handleError,
                'GET', `${this.getAssetPath('libraries', id)}/export?type=eagle&${ApplicationContext.detDataModelVersion()}`,
                {'Content-Type': 'application/json'},
                null
            )
        } catch (error) {
            console.error('Error ContentServerClient exportLibrary', error);
        }
    }

    getPackageExportLink (id, version){
        return `${this.getAssetPath("packages", id)}/export?type=eagle&datamodel_version=8.7.0&version=${version}`;
    };

    get3DModelTranslation (handleError, id, type = "model"){
        return this.request(
            "get this 3d model translation file",
            handleError,
            'GET', `${this.getAssetPath("3dmodels", id)}/${type}`,
            {'Content-Type': 'application/json'},
            null
        );
    };

    get3DModelPath(id, type) {
        return `${this.getAssetPath("3dmodels", id)}/${type}`;
    }

    getModelStatus (handleError, id, type){
        return this.request(
            "get this 3d model translation status",
            handleError,
            'GET', `${this.getAssetPath("3dmodels", id)}/${type}/status`,
            {'Content-Type': 'application/json'},
            null
        )
    };

    upload3DModelData (handleError, id, modelFile){
        return this.request(
            "upload this 3D model file",
            handleError,
            'POST', `${this.getAssetPath("3dmodels", id)}/model`,
            {},
            modelFile
        )
    };

    getPublicContent (type, filters = "&start=0&rows=5"){
        return this.request(
            `retrieve public ${type}`,
            handleError,
            'GET', `${this.getAssetPath(type)}?private=false&sort=updated_at%20desc${filters}`,
            {'Content-Type': 'application/json'},
            null
        );
    };

    getFile (handleError, type, filters = "", typeFilter = "?"){
        return this.request(
            `retrieve this file`,
            handleError,
            'GET', `${this.getAssetPath(type)}${typeFilter}${filters}`,
            {'Content-Type': 'application/json'},
            null
        )
    };

    // this endpoint now gives the latest version.
    getColabDoc (handleError, type, id){
        return this.request(
            "get this collab JSON",
            handleError,
            'GET', `${this.getAssetPath(type, id)}/colabDoc?${ApplicationContext.detDataModelVersion()}`,
            {'Content-Type': 'application/json'},
            null,
        )
    };

    getColabDocVersion (handleError, type, id, version){
        if(version == -1){
            console.error("don't call collabDoc endpoint with no version");
        }

        return this.request(
            "get this JSON version",
            handleError,
            'GET', `${this.getAssetPath(type, id)}/versions/${version}/colabDoc?${ApplicationContext.detDataModelVersion()}`,
            {'Content-Type': 'application/json'},
            null
        )
    };

    getMultiSavedSnapshot (handleError, query){
         return this.request(
            "retrieve these JSON snapshots",
            handleError,
            'GET', `${this.getAssetPath("actions")}/multiSavedSnapshot?&${ApplicationContext.detDataModelVersion()}${query}`,
            {'Content-Type': 'application/json'},
            null
        )
    };

    getOwnerHubs(handleError, regionId){
        return this.request(
            `get my ${fullHubAlias}s`,
            handleError,
            'GET', this.getAssetPath("hubs", null, regionId),
            {'Content-Type': 'application/json'},
            null
        )
    }

    getMemberofHubs(handleError, regionId){
        return this.request(
            `get my ${fullHubAlias} memberships`,
            handleError,
            'GET', `${this.getAssetPath("hubs", null, regionId)}/memberof`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    getInvitedToHub(handleError, regionId){
        return this.request(
            `get my ${fullHubAlias} invitations`,
            handleError,
            'GET', `${this.getAssetPath("hubs", null, regionId)}/invited_to`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    createHub(handleError, name, regionId){
        return this.request(
            `create a new ${fullHubAlias}`,
            handleError,
            'POST', this.getAssetPath("hubs", null, regionId),
            {'Content-Type': 'application/json'},
            {name}
        )
    }

    updateHub(handleError, hub){
        let {id, name, memberCount, owner} = hub;

        return this.request(
            `update this ${fullHubAlias}`,
            handleError,
            'PUT', `${this.getAssetPath("hubs")}/${id}`,
            {'Content-Type': 'application/json'},
            {id, name, memberCount, owner}
        )
    }

    deleteHub(handleError, id){
        return this.request(
            `delete this ${fullHubAlias}`,
            handleError,
            'PUT', `${this.getAssetPath("hubs")}/${id}`,
            {'Content-Type': 'application/json'},
            {deleted: true}
        )
    }


    undeleteHub(handleError, id){
        return this.request(
            `restore this ${fullHubAlias}`,
            handleError,
            'PUT', `${this.getAssetPath("hubs")}/${id}`,
            {'Content-Type': 'application/json'},
            {deleted: false}
        )
    }

    getHub(handleError, id, hubName){
        let hubDescription = (hubName)? `the ${fullHubAlias} "${hubName}"` : `this ${fullHubAlias}`
        return this.request(
            `retrieve information for ${hubDescription}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/${id}`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    getMembersHub(handleError, id){
        return this.request(
            `get the members of this ${fullHubAlias}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/${id}/members`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    getInvitesHub(handleError, id){
        return this.request(
            `get the invitations for this ${fullHubAlias}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/${id}/invite`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    // TODO all of the below should look like (handleError, hub, data).
    // the hub actions should probably all be the same.
    // then callers can pass down hub as one object and relevent information in another,
    // and here we can define what we need from each of those objects
    // Too much to change right now, but should refactor later.
    sendInvitationMembersHub(handleError, {hubId, inviteEmail}){
        return this.request(
            `send this invitation`,
            handleError,
            'POST', `${this.getAssetPath("hubs")}/${hubId}/invite`,
            {'Content-Type': 'application/json'},
            {inviteEmail}
        )
    }

    cancelInvitationHub(handleError, {hubId, lookup}){
        return this.request(
            "cancel this invitation",
            handleError,
            'GET', `${this.getAssetPath("hubs")}/${hubId}/invite/${lookup}/cancel`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    // watch out, the order of the parameters randomly switch here
    acceptInvitation(handleError, {lookup, hubId}, regionId){
        return this.request(
            "accept this invitation",
            handleError,
            'GET', `${this.getAssetPath("hubs", null, regionId)}/${hubId}/invite/${lookup}/accept`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    rejectInvitation(handleError, {lookup, hubId}, regionId){
        return this.request(
            "reject this invitation",
            handleError,
            'GET', `${this.getAssetPath("hubs", null, regionId)}/${hubId}/invite/${lookup}/reject`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    deleteMemberHub(handleError, {userId, hubId}){
        return this.request(
            "delete this member",
            handleError,
            'DELETE', `${this.getAssetPath("hubs")}/${hubId}/members/${userId}`,
            {'Content-Type': 'application/json'},
            null
        )

    }

    getListTransfersTo(handleError){
        return this.request(
            `get this ${fullHubAlias}'s transfer requests`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/transfer/to`,
            {'Content-Type': 'application/json'},
            null
        )

    }

    sendInvitationTransferHub(handleError, {hubId, idNewOwner}){
        return this.request(
            `transfer this ${fullHubAlias}`,
            handleError,
            'POST', `${this.getAssetPath("hubs")}/transfer`,
            {'Content-Type': 'application/json'},
            {newOwner: idNewOwner, hubId}
        )

    }

    getListTransfersFrom(handleError){
        return this.request(
            `get my ${fullHubAlias} transfers`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/transfer/from`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    cancelTransferHub(handleError, {transferId}){
        return this.request(
            `cancel the ownership transfer of this ${fullHubAlias}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/transfer/${transferId}/cancel`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    acceptTransferHub(handleError, {transferId}){
        return this.request(
            `accept the transfer of this ${fullHubAlias}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/transfer/${transferId}/accept`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    rejectTransferHub(handleError, {transferId}){
        return this.request(
            `reject the transfer of this ${fullHubAlias}`,
            handleError,
            'GET', `${this.getAssetPath("hubs")}/transfer/${transferId}/reject`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    loginCheck(handleError){
        return this.request(
            "check login",
            handleError,
            'GET', `${this.getAssetPath("actions", null, ApplicationContext.getHomeRegion())}/loginCheck`,
            {'Content-Type': 'application/json'},
            null
        )
    }

    attach3dModelsToPackagesInLibrary(handleError, libraryId, model3dMapping){
        return this.request(
          `attach 3d models to packages in this library`,
          handleError,
          'POST', `${this.getAssetPath("libraries", libraryId)}/attach3dModels`,
          {'Content-Type': 'application/json'},
          { model3dMapping }
        )
    }

    getAssetPath(type, id, regionId){
        var config = ApplicationContext.contentServer;
        var server = RegionUtil.getRegionServer(regionId);
        var path = `${server}/${config.tenant}/${type}`;
        if (id) path += "/" + id ;
        return path;
    }

    getLibraryDownloadPath(id, original){
        var config = ApplicationContext.contentServer;
        var server = RegionUtil.getRegionServer();
        var path = `${server}/${config.tenant}/libraries`;
        path += "/" + id + "/import/download" + (original ? "?original=true" : "");
        return path;
    }

    getGeneralRequest (handleError, {type, filters = "", typeFilter = "?", typeRequest = "GET", data = null, sync = false}){
        return this.request(
            "make unspecified request",
            handleError,
            typeRequest, `${this.getAssetPath(type)}${typeFilter}${filters}`,
            {'Content-Type': 'application/json'},
            data
        )
    }

    // TODO remove sync parameter.  (it doesn't work anyway)
    // we can use await if we want to be syncronus.
    request(intent, handleError, method, url, headers, objdata){
        const regionId = RegionUtil.regionFromServerUrl(url);

        let data = this.typeData(objdata);
        const doFetch = () => fetch(url, {
                "body": data,
                "async": true,
                "method": method,
                "headers": headers,
                "data-Type": "json",
                "cross-Domain": true,
                "withCredentials": true,
                "credentials": "include",
                "process-Data": data instanceof FormData ? false : true,
                "Content-Type": data instanceof FormData ? false : undefined,
            });

        return Promise.resolve()
        .then(() => SessionRecovery.withSessionRecovery(regionId, doFetch)
            .catch(err => {
                handleError(null, "connect to server",  "Check your connection and try again.");
                throw err;
            })
        ).then(res => {
            return this.handleResponse(handleError, res, intent);
        })
        // no catch here
    }

    typeData(obj){
        let data;
        if(obj) {
            if(typeof FormData !== 'undefined' && obj instanceof FormData) {
                data = obj;
            } else {
                data = JSON.stringify(obj);
            }
        }
        return data
    }

    handleResponse(handleError, response, intent){
       // console.log(response)
        if(response && response.ok) {
            let contentType = response.headers.get("content-type");
            if(contentType && contentType.includes("application/json")) {
                return response.json()
            }else{
                return response;
            }
        }
        handleError(response, intent);
        throw response;
    }

}

module.exports = new ContentServerClient();
